import { render, staticRenderFns } from "./lefttsmadiolg.vue?vue&type=template&id=3cfaf027&scoped=true&"
import script from "./lefttsmadiolg.vue?vue&type=script&lang=js&"
export * from "./lefttsmadiolg.vue?vue&type=script&lang=js&"
import style0 from "./lefttsmadiolg.vue?vue&type=style&index=0&id=3cfaf027&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfaf027",
  null
  
)

export default component.exports